(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["gander-home-featured-event"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('[data-ghe-countdown]').forEach(function (root) {
  var target = new Date(root.dataset.target);
  var end = root.dataset.end ? new Date(root.dataset.end) : null;
  var wrapper = root.parentElement;
  var liveMessageEl = wrapper ? wrapper.querySelector('[data-ghe-live-message]') : null;
  var daysEl = root.querySelector('[data-ghe-days]');
  var hoursEl = root.querySelector('[data-ghe-hours]');
  var minutesEl = root.querySelector('[data-ghe-minutes]');

  if (isNaN(target.getTime())) {
    root.remove();
    return;
  }

  function pad(n) {
    return String(n).padStart(2, '0');
  }

  function tick() {
    var now = new Date();

    if (end && !isNaN(end.getTime()) && now > end) {
      root.remove();
      clearInterval(timer);
      return;
    }

    if (now >= target) {
      root.hidden = true;
      if (liveMessageEl) {
        liveMessageEl.hidden = false;
        liveMessageEl.textContent = root.dataset.labelLive || 'Happening now!';
      }
      return;
    }

    var diff = target.getTime() - now.getTime();
    var days = Math.floor(diff / 86400000);
    var hours = Math.floor((diff % 86400000) / 3600000);
    var minutes = Math.floor((diff % 3600000) / 60000);

    if (daysEl) daysEl.textContent = pad(days);
    if (hoursEl) hoursEl.textContent = pad(hours);
    if (minutesEl) minutesEl.textContent = pad(minutes);
  }

  tick();
  var timer = setInterval(tick, 1000);
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gander-xmas-countdown"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('[data-gxd-countdown]').forEach(function (root) {
  var target = new Date(root.dataset.target);
  var end = root.dataset.end ? new Date(root.dataset.end) : null;
  var section = root.closest('.gxd');
  var liveMessageEl = section ? section.querySelector('[data-gxd-live-message]') : null;
  var daysEl = root.querySelector('[data-gxd-days]');
  var hoursEl = root.querySelector('[data-gxd-hours]');
  var minutesEl = root.querySelector('[data-gxd-minutes]');

  if (isNaN(target.getTime())) {
    section && section.remove();
    return;
  }

  function pad(n) {
    return String(n).padStart(2, '0');
  }

  function tick() {
    var now = new Date();

    if (end && !isNaN(end.getTime()) && now > end) {
      section && section.remove();
      clearInterval(timer);
      return;
    }

    if (now >= target) {
      root.hidden = true;
      if (liveMessageEl) {
        liveMessageEl.hidden = false;
        liveMessageEl.textContent = root.dataset.labelLive || 'Happening now!';
      }
      return;
    }

    var diff = target.getTime() - now.getTime();
    var days = Math.floor(diff / 86400000);
    var hours = Math.floor((diff % 86400000) / 3600000);
    var minutes = Math.floor((diff % 3600000) / 60000);

    if (daysEl) daysEl.textContent = pad(days);
    if (hoursEl) hoursEl.textContent = pad(hours);
    if (minutesEl) minutesEl.textContent = pad(minutes);
  }

  tick();
  var timer = setInterval(tick, 1000);
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
